import { unit } from '../../../../common/theme';
import { styled } from '../../../../providers/context/StyletronProvider/withStyletronProvider';

export const UploadPanelLinkContainer = styled('div', () => ({
  display: 'block',
  float: 'right',
  marginTop: `-${unit[4]}`,
  marginBottom: unit[6],
}));
